module.exports = __webpack_public_path__ + "img/2050-lg.6d80a04a.png";